import { isNil } from 'lodash';
import { Promise } from 'es6-promise';
import * as fetch from 'isomorphic-fetch';
import * as Shared from '../shared/shared-types';
import * as CLP from './category-landing-types';
import FilterStoreBase from '../shared/base-filter-store';

export interface ICategoryLandingStore {
    getInitialState(): CLP.ICategoryLandingFilterState;
    getUpdatedState(action: CLP.ICategoryLandingFilterAction): Promise<CLP.ICategoryLandingFilterState>;
}

export class CategoryLandingStore extends FilterStoreBase<CLP.ICategoryLandingFilterAction, CLP.ICategoryLandingFilterState>
    implements ICategoryLandingStore {

    private _categoryName: string;    

    constructor(endpoint: string, pageSize: number, categoryName: string) {
        
        super(endpoint, pageSize);
        this._categoryName = categoryName;

    }

    public getInitialState(): CLP.ICategoryLandingFilterState {

        return {
            page: 1,
            totalPages: 1,
            articles: new Array<Shared.IArticleListItem>(),            
            availableLetters: new Array<string>(),
            availableBodyParts: new Array<number>(),
            availableTopics: new Array<number>(),
            availableLanguages: new Array<string>()
        };

    }

    protected getCacheKey(action: CLP.ICategoryLandingFilterAction): string {        

        let key = `page:${action.page}`;
        if (!isNil(action.letter))
            key = key.concat(`|letter:${action.letter}`);
        if (!isNil(action.bodyPart))
            key = key.concat(`|bodyPart:${action.bodyPart}`);
        if (!isNil(action.topics) && action.topics.length)
            key = key.concat(`|topics:${action.topics.join(',')}`);
        if (!isNil(action.language))
            key = key.concat(`|language:${action.language}`);
        return key;

    }

    protected getRequestPayload(action: CLP.ICategoryLandingFilterAction): {} {

        return {
            pageSize: this._pageSize,
            category: this._categoryName,
            page: action.page,
            topics: action.topics,
            letter: action.letter,
            bodyPart: action.bodyPart,
            language: action.language
        };
                
    }

    protected parseStateData(stateData: any): CLP.ICategoryLandingFilterState {

        let typedData: {
            page: number,
            totalPages: number,
            articles: Array<Shared.IArticleListItem>,
            availableLetters: Array<string>,
            availableBodyParts: Array<number>,
            availableTopics: Array<number>,
            availableLanguages: Array<string>
        } = stateData;

        return {
            page: typedData.page,
            totalPages: typedData.totalPages,
            articles: typedData.articles,
            availableLetters: typedData.availableLetters.map(x => x.toLowerCase()),
            availableBodyParts: typedData.availableBodyParts,
            availableTopics: typedData.availableTopics,
            availableLanguages: typedData.availableLanguages
        };
    }

}


// WEBPACK FOOTER //
// ./~/source-map-loader!./app/src/clp/category-landing-store.ts